exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--editor__N322_{display:-webkit-box;display:-ms-flexbox;display:flex;padding:13px}.styles--editor__N322_.styles--editorAdvanced__20Gql{-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;padding:0}@media (min-width: 768px){.styles--editor__N322_.styles--editorAdvanced__20Gql{margin-top:-5px}.styles--editor__N322_.styles--editorAdvanced__20Gql.styles--editorExtended__dEAKj{margin-top:0}}.styles--editor__N322_.styles--editorAdvanced__20Gql>div{width:100%}@media (max-width: 767px){.styles--editor__N322_.styles--editorAdvanced__20Gql .cke_contents{max-height:100px}}\n", ""]);

// exports
exports.locals = {
	"editor": "styles--editor__N322_",
	"editorAdvanced": "styles--editorAdvanced__20Gql",
	"editorExtended": "styles--editorExtended__dEAKj"
};